import React, { useState } from 'react';
import {
    PlusOutlined
} from '@ant-design/icons';
import {
    Button,
    Form,
    Input,
    Modal,
    Select,
    message
} from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../config/axios';

export default function AddFormModal({ employees }) {

    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);

    const [messageApi, contextHolder] = message.useMessage();

    const queryClient = useQueryClient();
    const { isLoading, mutate } = useMutation({
        mutationFn: data => {
            axios
                .post('/api/user/', data)
                .then(() => {
                    messageApi.open({
                        type: 'success',
                        content: 'บันทึกข้อมูลสำเร็จ',
                        duration: 1,
                        onClose: () => form.resetFields()
                    });
                    queryClient.invalidateQueries(['/api/user/'])
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                    });
                })
        },
    });

    const onCreate = () => {
        form
            .validateFields()
            .then(values => mutate(values))
            .catch(err => {
                console.log(err)
                messageApi.open({
                    type: 'error',
                    content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                });
            })
    };

    const onCancelCreate = () => {
        form.resetFields();
        setOpen(false);
    }
    return (
        <div>
            {contextHolder}
            <Button
                type='primary'
                icon={<PlusOutlined />}
                onClick={() => setOpen(true)}
            >เพิ่ม</Button>
            <Modal
                open={open}
                title="เพิ่มบัญชีผู้ใช้งาน"
                onCancel={onCancelCreate}
                footer={[
                    <Button key="back" onClick={onCancelCreate}>
                        ยกเลิก
                    </Button>,
                    <Button key="submit" type="primary" disabled={isLoading} onClick={onCreate}>
                        ตกลง
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    layout="vertical"
                    name={`addUser`}
                >
                    <Form.Item
                        name="username"
                        label="ชื่อบัญชีผู้ใช้งาน"
                        rules={[
                            {
                                required: true,
                                message: 'กรุณากรอกข้อมูล',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        label="รหัสผ่าน"
                        rules={[
                            {
                                required: true,
                                message: 'กรุณากรอกข้อมูล',
                            },
                        ]}
                    >
                        <Input.Password />
                    </Form.Item>
                    <Form.Item
                        label="ประเภทบัญชีผู้ใช้งาน"
                        name="role"
                        rules={[
                            {
                                required: true,
                                message: 'กรุณากรอกข้อมูล!',
                            },
                        ]}
                    >
                        <Select
                            placeholder="เลือกประเภทบัญชีผู้ใช้งาน"
                        >
                            {
                                ["ADMIN", "USER", "ACCOUNTING"].map(item => <Select.Option key={item} value={item._id}>{item.name}</Select.Option>)
                            }
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="พนักงาน"
                        name="employee"
                        rules={[
                            {
                                required: true,
                                message: 'กรุณากรอกข้อมูล!',
                            },
                        ]}
                    >
                        <Select
                            placeholder="เลือกพนักงาน"
                        >
                            {
                                employees.map(item => <Select.Option key={item._id} value={item._id}>{item.fname}</Select.Option>)
                            }
                        </Select>
                    </Form.Item>
                </Form>
            </Modal>
        </div>

    )
}
